module.exports = __webpack_public_path__ + "img/cl.fc539f4a.png";